import React from "react";

export default function Function() {
    return (
        <header className="hg-150">
            <div className="clouds-container">
                <div className="clouds1"></div>
                <div className="clouds2"></div>
                <div className="clouds3"></div>
                <div className="clouds4"></div>            
            </div>

            <a href="/" className="t-dec-none">
                <h1 className="ft-primary text-center vertical-center">Magikus Studios</h1>
            </a>
        </header>
    );
}